import { MessageCircle } from "lucide-react";
import { COMPANY } from "../lib/brand";

export default function WhatsAppFloat({ number, message }) {
  const wa = (number || COMPANY.whatsapp || "").replace(/\D/g, "");
  const text =
    message ||
    `Hello ${COMPANY.name}, I'm reaching out from your website. Please share information about your mining safety products & services.`;
  const href = `https://wa.me/${wa}?text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label={`Chat with ${COMPANY.shortName} on WhatsApp`}
      title={`Chat with ${COMPANY.name} on WhatsApp`}
      className="fixed bottom-6 right-6 z-50 group"
    >
      {/* Animated outer ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <span className="relative flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1ebe5b] text-white shadow-[0_15px_30px_-8px_rgba(37,211,102,0.55)] transition-all rounded-full pl-3 pr-4 py-3">
        {/* WhatsApp glyph */}
        <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white shrink-0" aria-hidden="true">
          <path d="M19.05 4.91A10 10 0 0 0 12 2 10 10 0 0 0 2 12a9.94 9.94 0 0 0 1.34 5L2 22l5.13-1.34A10 10 0 0 0 12 22a10 10 0 0 0 7.05-17.09zM12 20.13a8.13 8.13 0 0 1-4.13-1.13l-.3-.18-3 .79.8-2.92-.19-.3A8.12 8.12 0 1 1 12 20.13zm4.46-6.1c-.24-.12-1.43-.7-1.65-.78s-.38-.12-.55.12-.63.78-.77.94-.28.18-.52.06a6.62 6.62 0 0 1-1.95-1.2 7.36 7.36 0 0 1-1.36-1.69c-.14-.24 0-.37.11-.49.11-.11.24-.28.36-.42a1.6 1.6 0 0 0 .24-.4.45.45 0 0 0 0-.42c-.06-.12-.55-1.32-.75-1.81s-.4-.4-.55-.41h-.47a.92.92 0 0 0-.66.31 2.78 2.78 0 0 0-.87 2.06 4.83 4.83 0 0 0 1 2.55 11 11 0 0 0 4.21 3.7 14.18 14.18 0 0 0 1.41.52 3.39 3.39 0 0 0 1.55.1 2.55 2.55 0 0 0 1.66-1.17 2 2 0 0 0 .14-1.17c-.06-.1-.21-.16-.45-.28z"/>
        </svg>
        <span className="hidden sm:inline-flex flex-col leading-tight">
          <span className="text-[9px] font-bold uppercase tracking-[0.2em] opacity-90">Chat with us</span>
          <span className="text-[12px] font-extrabold tracking-tight">Universal EE</span>
        </span>
      </span>
      <span className="sr-only">Chat on WhatsApp</span>
    </a>
  );
}
